export enum DeepLinkPage {
  UpdateEmail = 'update-email',
  MFA = 'mfa',
  Recovery = 'recovery',
}
